import { render } from "./ClanPage.vue?vue&type=template&id=4c6f55eb&scoped=true"
import script from "./ClanPage.vue?vue&type=script&lang=js"
export * from "./ClanPage.vue?vue&type=script&lang=js"

import "./ClanPage.vue?vue&type=style&index=0&id=4c6f55eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6f55eb"]])

export default __exports__